import React from "react";
import FooterLogo from '../../../../assets/images/logo-1.png';
import Branch from '../../../../models/branch.model';
import { DvNumber } from "../../../../utils/common.utils";
import { lang } from '../../../../config/app.config';
import translates from '../../../../translation.json';
// import {TranslationState} from '../../../../store/ActionReducers/translation.actionreducer';
interface Props {
  branch?: Branch | undefined,
}

// interface state {
//   translation:TranslationState
// }

const FooterAbout: React.FC<Props> = ({ branch }) => {

  return (
    <div className="footer-about">
      <div className="img-wrapper">
        <img src={FooterLogo} alt="" />
      </div>
      {branch ?
        <ul>
          <li>
            {/* <span className="dev-number">
              {branch.district ? branch.district : branch.province}  {`${branch?.address?.ward ? '- ' + branch?.address?.ward : ''}`},</span> {branch.address ? `${branch.address.municipality}` : ''} */}
            {branch?.translations[0]?.office_address ?? (branch.district || branch.province)}
          </li>
          <li className="dev-number">{translates.translation[lang].phone}: {lang === 'np' ? DvNumber((branch.phone).toString()) : branch.phone}</li>
          {/* <li>Fax: (977 - 1) 4229227/ 4225580</li> */}
          <li className="eng-number">{translates.translation[lang].email} :  {branch.email}</li>
        </ul> : ''
      }
    </div>
  );
}

export default FooterAbout;